var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "Username" },
            model: {
              value: _vm.value.username,
              callback: function ($$v) {
                _vm.$set(_vm.value, "username", $$v)
              },
              expression: "value.username",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "Email" },
            model: {
              value: _vm.value.email,
              callback: function ($$v) {
                _vm.$set(_vm.value, "email", $$v)
              },
              expression: "value.email",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "Firstname" },
            model: {
              value: _vm.value.firstname,
              callback: function ($$v) {
                _vm.$set(_vm.value, "firstname", $$v)
              },
              expression: "value.firstname",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "Lastname" },
            model: {
              value: _vm.value.lastname,
              callback: function ($$v) {
                _vm.$set(_vm.value, "lastname", $$v)
              },
              expression: "value.lastname",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "Phone" },
            model: {
              value: _vm.value.phone,
              callback: function ($$v) {
                _vm.$set(_vm.value, "phone", $$v)
              },
              expression: "value.phone",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-select", {
            attrs: { fancy: "", label: "Taal", items: _vm.langItems },
            model: {
              value: _vm.value.lang,
              callback: function ($$v) {
                _vm.$set(_vm.value, "lang", $$v)
              },
              expression: "value.lang",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-checkbox", {
                attrs: { label: "Activated" },
                model: {
                  value: _vm.value.activated,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "activated", $$v)
                  },
                  expression: "value.activated",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.sendActivationEmail()
                    },
                  },
                },
                [_vm._v(" Send activation email ")]
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-checkbox", {
                attrs: {
                  label:
                    "Gebruiker verbergen in de klant zijn dossier (niet gefactureerd)",
                },
                model: {
                  value: _vm.value.QuietMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "QuietMode", $$v)
                  },
                  expression: "value.QuietMode",
                },
              }),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-checkbox", {
                attrs: {
                  label:
                    "Boekhouder (toont portaal met klant-dossiers bij login)",
                },
                model: {
                  value: _vm.value.isAccountant,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "isAccountant", $$v)
                  },
                  expression: "value.isAccountant",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.value.totpEnabled },
              on: {
                click: function ($event) {
                  return _vm.disableTwoFactorAuth()
                },
              },
            },
            [_vm._v(" Disable two factor authentication ")]
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input", {
            attrs: {
              value: _vm.password,
              fancy: "",
              password: !_vm.showPassword,
              icon: _vm.passwordIcon,
              label: "Wachtwoord (Leeg laten indien het niet verandert is)",
            },
            on: {
              "icon-click": function ($event) {
                _vm.showPassword = !_vm.showPassword
              },
              input: function ($event) {
                return _vm.passwordUpdate($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-select-user-device", {
            attrs: {
              fancy: "",
              label: "Gebruiker enkel beperken tot toestel",
              "company-id": _vm.value.companyId,
            },
            model: {
              value: _vm.value.deviceId,
              callback: function ($$v) {
                _vm.$set(_vm.value, "deviceId", $$v)
              },
              expression: "value.deviceId",
            },
          }),
        ],
        1
      ),
      _c("w-col", { attrs: { xs: "12" } }, [
        _vm._v(" Beperken tot IP adressen: "),
      ]),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-list",
            [
              _vm.value.restrictedToIpAddresses.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v("Geen IP Adressen toegevoegd"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.value.restrictedToIpAddresses, function (ip, i) {
                return _c(
                  "w-list-item",
                  { key: i },
                  [
                    _c(
                      "w-list-item-text",
                      [
                        _c("w-input", {
                          attrs: {
                            "has-error": !_vm.isIpAddressValid(ip),
                            placeholder: "IP Adres",
                          },
                          model: {
                            value: _vm.value.restrictedToIpAddresses[i],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value.restrictedToIpAddresses,
                                i,
                                $$v
                              )
                            },
                            expression: "value.restrictedToIpAddresses[i]",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.value.restrictedToIpAddresses.splice(
                                  i,
                                  1
                                )
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  attrs: { disabled: _vm.value.isOwner },
                  on: {
                    click: function ($event) {
                      return _vm.value.restrictedToIpAddresses.push("")
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [_vm._v("Adres toevoegen")]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }